import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			height: '100%',
			justifyContent: 'center',
			alignItems: 'center',
			fontFamily: 'Instrument Sans, sans-serif',
		},
		blockWrap: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			flexDirection: 'column',
			width: '100%',
			maxWidth: theme.spacing(106.5),
			height: theme.spacing(41.5),
			backgroundColor: theme.palette.scoreapp.paper,
			border: `2px dashed ${theme.palette.scoreapp.primary}`,
			borderRadius: 10,
			[theme.breakpoints.down('sm')]: {
				margin: `0 ${theme.spacing(2)}`,
				padding: theme.spacing(1),
			},
			[theme.breakpoints.up('sm')]: {
				margin: `0 ${theme.spacing(3)}`,
				padding: theme.spacing(1),
			},
		},
		text: {
			width: '100%',
			maxWidth: theme.spacing(34.5),
			fontSize: theme.spacing(2),
			fontWeight: 700,
			letterSpacing: 0.27,
			textAlign: 'center',
			color: theme.palette.scoreapp.dark,
		},
		button: {
			width: theme.spacing(16.75),
			height: theme.spacing(4.5),
			marginTop: theme.spacing(2),
			fontSize: theme.spacing(1.9),
			letterSpacing: 0.25,
			color: theme.palette.scoreapp.primary,
			border: `1px solid ${theme.palette.scoreapp.primary}`,
			fontWeight: 500,
			whiteSpace: 'nowrap',
			fontFamily: 'inherit',
		},
	}),
	{
		name: 'EmptyMainSection',
	},
)

export default useStyles
